<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">
    <el-row style="padding: 0px 20px;height: 98%">
      <div class="dash-line" style="padding: 0px 20px;min-height: 38vh;height: 100%">
        <el-tabs @tab-click="handleClick" style="height: 100%">
          <el-row style="height: 70%">
            <el-col :lg="8">
              <div v-for="con in control" :key="con.id" @touchstart="controlDvrDoor(accessList[0].hcId,con,con.id)"  @click="controlDvrDoor(accessList[0].hcId,con,con.id)" class="controlButton pointer" style="margin-top: 10px">{{con.name}}</div>
            </el-col>
            <el-col :lg="24" style="margin-top: 20px;height: 70%">
              <!--      开门记录-->
              <el-row >
                <el-table
                  :data="doorLogs.data"
                  border
                  class="m-auto"
                  height="40vh"
                  style="width: 100%;">
                  <el-table-column
                    align="center"
                    label="序号"
                    width="80"
                    type="index"
                    :index="changeIndex">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="控制器"
                    prop="hcName">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="卡号"
                    prop="card">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="用户名"
                    prop="user">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="工号"
                    prop="number">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="卡类型"
                    prop="cardType">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="主类型"
                    prop="majorType">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="次类型"
                    prop="minorType">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="门名称"
                    prop="door">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="时间"
                    prop="time">
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row class="margin-top-30" v-if="doorLogs.count > doorLogs.max">
                <el-pagination
                  :current-page.sync="doorGetSetting.data.page"
                  :page-size.sync="doorLogs.max"
                  :total="doorLogs.count"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next,jumper">
                </el-pagination>
              </el-row>
            </el-col>
          </el-row>
        </el-tabs>
      </div>

    </el-row>
  </div>
</template>

<script>
import {getLatestDay} from "@/assets/js/DateFormat";
import {getCookie, setCookie} from "@/utils/common";
import {passwordVerifiers} from "@/network/account";

export default {
  name: "HKDoor2",
  props: ['deviceInfo', 'alarmInfoList'],
  data() {
    return {
      // 开门记录
      logs: [],
      doorLogs: {},
      doorLogList: [],
      portProperties: {},
      activeId: "1",
      doorNum: null, //门编号
      byIndicatorLightStatus: 0, //指示灯状态，0-掉线，1-在线
      doorNameList: [],//门名称
      doorStatus: [], //门状态 1- 休眠，2- 常开状态（对于梯控，表示自由状态），3- 常闭状态（对于梯控，表示禁用状态），4- 普通状态（对于梯控，表示受控状态）
      byCardReaderOnlineStatus: [],//读卡器在线状态，0-不在线，1-在线
      date: '',
      currentPage: 1,
      pageSize: 10,
      commandId: null,
      // 获取开门记录的请求参数
      doorGetSetting: {
        command: 'getHcLogs',
        data: {
          page: 1,//记录分页的页数
          index: 0,
          max: 20,
        }
      },
      websocket: null,
      accessList:[],
      doorList:[],
      // control: [{id: 0, name: "关闭"}, {id: 1, name: "远程开门"}, {id: 2, name: "常开"}, {id: 3, name: "常关"}]
      control: [{id: 1, name: "远程开门"}],
      userList: {user:{userArray:[]},door:{doorArray:[]}}, //用户列表
    }
  },
  watch: {
    activeId: {
      handler(val) {
        console.log(this.doorNum, val, "---门编号--");
      }
    }
  },
  mounted() {
    this.initDoor()
  },
  created() {
    this.date = getLatestDay()
  },
  destroyed() {
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  },
  filters: {
    changeDoorStatus: function (param) {
      switch (param) {
        case 1:
          return '休眠';
        case 2:
          return '常开';
        case 3:
          return '常闭';
        case 4:
          return '普通';
      }
    }
  },
  methods: {
    //获取用户
    sendGetUsers() {
      if (this.websocket) {
        for (let access of this.accessList){
          this.websocket.send(JSON.stringify({command: 'getHcUser', data: access}))
        }
      }
    },
    handleCurrentChange(val) {
      this.doorGetSetting.data.page = val;
      this.doorGetSetting.data.index = this.doorGetSetting.data.max * (val - 1);
      this.sendGetLogs();
    },
    getHcUser(data) {
      // this.userList = {user:{userArray:[]},door:{doorArray:[]}}
      if (data.info.result === 'OK') {
        if(!data.data.user.userArray){
          return
        }
        data.data.user.userArray.forEach(item => {
          item.doorList=data.data.door.doorArray
          item.door=''
          if(item.doorPower===-1){
            item.doorNo=data.data.door.doorArray.map(item => item.doorId+'')
            item.door='所有门'
          }else {
            if(!data.data.door.doorArray){
              item.door=item.doorNo
            }else{
              if(item.doorNo){
                // 根据doorNo，逗号分隔后，循环查找对应的门
                // 这里要字符串类型
                let doorNoList=item.doorNo.split(",")
                item.doorNo=doorNoList.map(item =>parseInt(item))
                doorNoList.forEach(doorNo =>{
                  let door=data.data.door.doorArray.filter(door => door.doorId == doorNo && door.hcId == item.hcId);
                  item.door=item.door?item.door+","+door[0].doorName:item.door+door[0].doorName
                })
              }else {
                item.door=''
              }
            }
          }
        })
        this.userList.user.userArray = this.userList.user.userArray.concat(data.data.user.userArray)
        this.userList.door.doorArray = this.userList.door.doorArray.concat(data.data.door.doorArray)
      }
    },
    setHcDoor(data) {
      if (data.info.result === 'OK') {
        this.$message.success("开门成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
    },
    changeIndex(val) {
      return (this.doorGetSetting.data.page - 1) * this.doorGetSetting.data.max + val + 1
    },
    initData() {
      this.userList = {user:{userArray:[]},door:{doorArray:[]}}//用户列表
      this.doorLogs = {}
      this.commandId = null
      this.doorList = [] //门列表
      this.accessList = [] //控制器列表
      this.areaList = []//区域列表
    },
    initDoor() {
      this.portProperties = JSON.parse(this.deviceInfo.portProperties)
      // this.getDoorAcsWorkStatus();
      this.initDoorWebsocket();
    },
    // 初始化websocket
    initDoorWebsocket() {
      this.initData();
      if (this.websocket) {
        this.websocket.close()
        this.websocket = null
      }
      let properties = this.portProperties
      console.log(properties)
      // this.websocket = new WebSocket('ws://' + window.location.host+":"+window.g.ports+"/ws/access")
      this.websocket = new WebSocket('ws://' + properties.IP + ':' + properties.PORT)
      // this.websocket = new WebSocket('ws://192.168.75.240:6060')
      // 连接成功
      this.websocket.onopen = () => {
        this.sendGetLogs() //获取刷卡记录
        this.sendGetAccess();//获取控制器列表
      }
      this.websocket.onerror = () => {
        console.log("ws出错");
        this.initData();
      }
      // 消息回调
      this.websocket.onmessage = (e) => {
        let websocketObj = JSON.parse(e.data)
        this[websocketObj.command](websocketObj)
      }
    },
    sendWebsocket(command, data) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: command, data: data}))
      }
    },
    //获取控制器
    sendGetAccess() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getHcAccess'}))//获取控制器
      }
    },
    // 向门禁发送获取开门记录命令
    sendGetLogs() {
      if (this.websocket && this.websocket.readyState===WebSocket.OPEN) {
        this.websocket.send(JSON.stringify(this.doorGetSetting))
      }else{
        console.log('websocket连接异常断开')
        let properties = this.deviceInfo.attribute
        this.websocket = new WebSocket('ws://' + properties.IP + ':' + properties.PORT)
        this.websocket.onopen = () => {
          this.sendGetLogs() //获取刷卡记录
        }
      }
    },
    // 获取开门记录回调
    getHcLogs(data) {
      this.doorLogs = data
    },
    getHcAccess(data) {
      this.doorList=[]
      this.accessList = []
      let doorLists = []
      if (data.info.result === 'OK') {
        this.accessList = data.data
        this.sendGetUsers()
        if (this.accessList.length) {
          this.accessList.forEach(item => {
            if (item.door.length) {
              item.door.forEach(door => {
                if (typeof door === 'object' && door !== null) {
                  door.devSn = item.devSn;
                  door.edit = false;
                  doorLists.push(door);
                }
              })
            }
          })
        }
      }
      this.doorList=doorLists
    },
    //控制门
    controlDvrDoor(hcId, door, switching) {
      let data = {hcId: hcId, door: door.id, control: switching}
      if(getCookie("passwordVerification") === '1'){
        if (this.websocket) {
          this.websocket.send(JSON.stringify({command: 'setHcDoor', data: data}))
        }
      }else{
        this.$prompt('请输入系统登录密码确认身份', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
        }).then(({value}) => {
          passwordVerifiers(value).then(res =>{
            if (res.data === true){
              setCookie("passwordVerification",'1',null);
              if (this.websocket) {
                this.websocket.send(JSON.stringify({command: 'setHcDoor', data: data}))
              }
              this.functionDialogVisible = false;
            }else{
              this.$message({
                message: '系统登录密码错误',
                type: 'warning'
              });
              return;
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 日期选择
    formChange() {
      this.getDvrDoorLogs()
    }
  }
}
</script>

<style scoped>
.el-tabs >>> .el-tabs__item.is-top {
  color: #07E6F8;
  padding: 0 10px;
}

.el-tabs >>> .el-tabs__item.is-top.is-active {
  color: #299BFF;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
  background-color: rgba(41, 155, 255, .2);
}

.controlButton {
  padding: 0 15px;
  border-radius: 15px;
  border: 1px solid rgba(41, 155, 255, .5);
  display: inline-block;
  margin-right: 10px;
  margin-top: 20px;
}
</style>
